import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import { DatePicker } from 'material-ui-pickers';
import * as React from 'react';
import { Element } from 'react-scroll';
import { WrappedFieldInputProps, WrappedFieldMetaProps, WrappedFieldProps } from 'redux-form';

import * as addDebtStyles from '../../../AddDebt/AddDebtForm/AddDebtForm.css';
import { getInputAdornment } from '../../format';

interface CustomFieldProps {
  type: string;
  label: string;
  disabled?: boolean;
  fieldFormat?: FieldFormat;
  input?: WrappedFieldInputProps | { value: string; name: string };
  meta?: WrappedFieldMetaProps;
}

export const FullWidthTextField = (props: CustomFieldProps) => (
  <Grid container justify="center">
    <Grid item xs={11}>
      <Element name={props.input && (props.input.name as any)}>
        <TextField
          {...props.input}
          id={props.input && props.input.name}
          label={props.label}
          InputProps={{
            ...getInputAdornment(props.fieldFormat),
            style: props.fieldFormat ? { width: 'auto' } : {},
          }}
          disabled={props.disabled}
          margin="normal"
          type={props.type}
          InputLabelProps={props.type === 'date' ? { shrink: true } : {}}
          fullWidth
          variant="outlined"
        />
      </Element>
      {props.meta && props.meta.touched && props.meta.error && (
        <span style={{ color: '#d13f3f' }}>
          <i>{props.meta.error}</i>
        </span>
      )}
    </Grid>
  </Grid>
);

export const SelectField = (
  props: WrappedFieldProps & {
    disabled?: boolean;
    label: string;
    dataMap: Array<{ value: string; name: string }>;
  }
) => (
  <Grid container justify="center">
    <Grid item xs={11}>
      <Element name={props.input && (props.input.name as any)}>
        <TextField
          select
          {...props.input}
          label={props.label}
          id={props.input.name}
          fullWidth
          disabled={props.disabled}
          margin="normal"
          variant="outlined">
          {props.dataMap.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Element>
      {props.meta && props.meta.touched && props.meta.error && (
        <span>
          <i>{props.meta.error}</i>
        </span>
      )}
    </Grid>
  </Grid>
);

export const CheckBoxField = (props: WrappedFieldProps & { type: string; label: string }) => (
  <>
    <Element name={props.input && (props.input.name as any)}>
      <FormControlLabel
        control={
          <Checkbox
            {...props.input}
            id={props.input.name}
            value={props.input.value === true ? 'true' : undefined}
            color="primary"
          />
        }
        label={props.label}
      />
    </Element>
    <Grid container justify="center">
      {props.meta && props.meta.touched && props.meta.error && (
        <span>
          <i>{props.meta.error}</i>
        </span>
      )}
    </Grid>
  </>
);
export const RadioField = (
  props: WrappedFieldProps & {
    type: string;
    label: string;
    options: Array<{ value: string; name: string }>;
    disabled?: boolean;
  }
) => (
  <>
    <Element name={props.input && (props.input.name as any)}>
      <RadioGroup {...props.input}>
        {props.options.map((options) => (
          <FormControlLabel
            key={options.value}
            value={options.value}
            control={<Radio color="primary" disabled={props.disabled} />}
            label={options.name}
          />
        ))}
      </RadioGroup>
    </Element>
    <Grid container justify="center">
      {props.meta && props.meta.touched && props.meta.error && (
        <span>
          <i>{props.meta.error}</i>
        </span>
      )}
    </Grid>
  </>
);

export const DatePickerField = (
  props: WrappedFieldProps & { disabled?: boolean; label: string; type: FieldType }
) => (
  <Grid container justify="center">
    <Grid item xs={11}>
      <DatePicker
        {...props.input}
        disabled={props.disabled}
        value={props.input.value || null}
        variant="outlined"
        label={props.label}
        className={addDebtStyles.datePicker}
        fullWidth
        format="MM/dd/yyyy"
      />
    </Grid>
  </Grid>
);
